export default "__VITE_ASSET__BjlDViSU__"